import React, { useEffect, useState, useTransition } from "react";
import { Modal } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { DepotDefautOrganisation } from "../../../_App/Redux/Slices/depot/depotSlice";
import {
  findBonByBarcode,
  ListBonsReduction,
  saveBonReductionApi,
} from "../../../_App/Redux/Slices/reduction/reductionSlice";
import {
  Panier,
  setReduction,
} from "../../../_App/Redux/Slices/Caisse/PanierSlice";
import { ToastWarning } from "../../../Shared/Toasts/ToastWarning";
import { formadate, ImpressionTicket } from "../../../_App/Helpers/helpers";
import BonReductionType from "../../../_App/Types/Entites/ReductionType";
import BonDeReductionTicket from "../TicketDeCaisse/BonDeReduction";
import { parametrageCaisse } from "../../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import {
  SelectedOrganisation,
  societe,
} from "../../../_App/Redux/Slices/Auth/authSlice";
import { PrintAction } from "../../../Shared/Hardware/PrintAction";
import iconv from "iconv-lite"; // npm i iconv-lite

const ReductionModal = ({ ShowModal, setShowModal }: any) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const currentDepot = useAppSelector(DepotDefautOrganisation);
  const parametrage = useAppSelector(parametrageCaisse);
  const [selectedType, setSelectedType] = useState<any>("reçu");
  const [ShowModalTicket, setShowModalTicket] = useState(false);
  const cart = useAppSelector(Panier);
  const [code, setCode] = useState<any>("");
  const [idbon, setIdBon] = useState();
  const Societe = useAppSelector(societe);
  const Organisation = useAppSelector(SelectedOrganisation);

  const bonsReduction = useAppSelector(ListBonsReduction);

  const [amount, setAmount] = useState<string>();

  const handleFindBon = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();

    const resp = await dispatch(findBonByBarcode(code));
    const bonsReduction = resp.payload;
    const today = new Date();

    if (bonsReduction && bonsReduction) {
      const expireDate = new Date(bonsReduction.dateEcheance);

      const expireDateLocal = new Date(
        expireDate.getTime() + expireDate.getTimezoneOffset() * 60000
      );
      if (expireDateLocal < today) {
        ToastWarning("Ce bon de réduction est expiré !");
      } else {
        if (!bonsReduction.valide) {
          ToastWarning("Ce bon est déjà utilisé!");
          setShowModal(false);
        } else {
          if (cart.Bons.some((item: any) => item._id === bonsReduction._id)) {
            ToastWarning("Ce bon est déjà selectionné !");
          } else {
            dispatch(
              setReduction({
                amount: Number(bonsReduction.amount.toFixed(3)),
                bon: bonsReduction,
              })
            );
          }
          setShowModal(false);
        }
      }
    } else {
      ToastWarning("Bon de réduction introuvable !");
    }
  };

  function generateCode(): string {
    const timestamp = Date.now();
    const uniqueId = timestamp % 1000000;
    return uniqueId.toString().padStart(6, "0");
  }

  const saveBonReduction = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const today = new Date();

    // Create a new date that is 2 weeks later
    const twoWeeksLater = new Date(today);
    if (parametrage.duree_bon) {
      twoWeeksLater.setDate(today.getDate() + Number(parametrage.duree_bon));
    } else {
      twoWeeksLater.setDate(today.getDate() + 15);
    }
    let data: BonReductionType = {
      date: today,
      amount: Number(amount),
      dateEcheance: twoWeeksLater,
      depot_id: currentDepot._id,
      code: generateCode(),
      type: "Bon de réduction",
      consumed: 0,
      sous_bon: false,
      valide: true,
    };
    const res = await dispatch(saveBonReductionApi(data));
    if (res.payload.success) {
      setIdBon(res.payload.data._id);
      const dataBon = { bon: res.payload.data };
      console.log("dataBon",dataBon)
      await callImpression(dataBon, "Bon");
      setShowModal(false)
    }
  };
  //call impression
  const callImpression = async (dataTicket: any, type: any) => {
    const lines: any = ImpressionTicket(
      type,
      {
        ...dataTicket,
        societe: Societe,
        organisation: Organisation,
      },
      parametrage
    );

    const finalBuffer = (() => {
      const allBytes: number[] = [];
      lines.forEach((line: any) => {
        if (line instanceof Uint8Array) {
          allBytes.push(...line);
        } else {
          const buf = iconv.encode(line + "\n", "ISO-8859-1");
          allBytes.push(...buf);
        }
      });
      return new Uint8Array(allBytes);
    })();

    await PrintAction(finalBuffer,parametrage.OpenTiroire);
  };

  return (
    <>
      <BonDeReductionTicket
        ShowModal={ShowModalTicket}
        setShowModal={setShowModalTicket}
        setShowModalForm={setShowModal}
        Bon_id={idbon}
      />

      <Modal show={ShowModal} onHide={() => setShowModal(false)}>
        <Modal.Header>
          <Modal.Title>
            <span
              className="modal-title"
              id="addCategorieLabel"
              onClick={() => console.log()}
            >
              {" "}
              Bon de réduction
            </span>
          </Modal.Title>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={(e) => {
              setShowModal(false);
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </Modal.Header>
        <form onSubmit={saveBonReduction}>
          <Modal.Body>
            <nav id="payment-block">
              <ul className="menu-payments" style={{ padding: "0px 20px" }}>
                <li className="menu">
                  <a
                    href="#uiKit"
                    data-active="false"
                    className="menu-toggle"
                    onClick={() => setSelectedType("don")}
                    style={{
                      backgroundColor:
                        selectedType && selectedType === "don"
                          ? "lightblue" // Change to the desired background color
                          : "",
                    }}
                  >
                    <div className="base-menu">
                      <div className="base-icons">
                        <i className="fas fa-tags"></i>{" "}
                      </div>
                      <span>Générer un bon de réduction</span>
                    </div>
                  </a>
                </li>
                <li className="menu">
                  <a
                    href="#uiKit"
                    data-active="false"
                    className="menu-toggle"
                    onClick={() => setSelectedType("reçu")}
                    style={{
                      backgroundColor:
                        selectedType && selectedType === "reçu"
                          ? "lightblue" // Change to the desired background color
                          : "",
                    }}
                  >
                    <div className="base-menu">
                      <div className="base-icons">
                        <i className="fas fa-tags"></i>{" "}
                      </div>
                      <span>Chercher un bon de réduction</span>
                    </div>
                  </a>
                </li>
              </ul>
            </nav>

            <div className="row">
              {selectedType && selectedType === "don" ? (
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="libelle">{t("amount")}</label>
                    <input
                      className="form-control mb-2"
                      type="number"
                      id="montant"
                      onChange={(e) => setAmount(e.currentTarget.value)}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div className="col-10">
                    <div className="form-group">
                      <label htmlFor="search">
                        Trouver le bon de réduction
                      </label>
                      <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="Recherche bon reduction"
                        onChange={(e) => setCode(e.currentTarget.value)}
                      />
                    </div>
                  </div>
                  <div
                    className="col-2"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <button
                      className="btn mt-2"
                      onClick={(e) => handleFindBon(e)}
                    >
                      {" "}
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="reset"
              onClick={(e) => {
                setShowModal(false);
              }}
              className="btn btn-primary-app"
            >
              Annuler
            </button>
            {selectedType && selectedType === "don" ? (
              <button type="submit" className="btn btn-primary-app">
                Enregistrer
              </button>
            ) : null}
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default ReductionModal;
